import React, { useEffect, useRef, useState } from 'react'
import "./AsmDetail.css"
import arr from "../../images/downarr.svg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import nacho2 from "../../images/nach2.png"
import gland from "../../images/gland.png"
import nacho5 from "../../images/nach5.png"
import { IMG_URL } from '../../config';
import Asm from '../Asm/Asm'
import axios from 'axios';
import { END_URL } from "../../config";
import { Helmet } from 'react-helmet';
import gg from "../../images/pp-logo.gif"; // 🧩 Added logo loader
import Archetype from '../Archetype/Archetype';
import Testimonial from '../Testimonial/Testimonial';
import Popularity from '../Popularity/Popularity';

function AsmDetail({ onLoginChange,token,free_test_slug }) {

  const [archetype, setarchetype] = useState([]);

  const [archetypeData, setArchetypeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [home, setHome] = useState(null);

  const [openIndex, setOpenIndex] = useState(0);

  const [seo, setSeo] = useState({});

  const [BannerData, setBannerData] = useState({});

  const asm_page = true;

  const navigate = useNavigate();

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

    const LoginShow = () => {

        window.scrollTo({ top: 0, behavior: 'smooth' });
        onLoginChange(true);
        
    };

    const AttendTest = () => {

        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });

       navigate(`/test/${free_test_slug}`);
        
    };

    

  const nachoSections = [
    {
      key: "N",
      label: "Natural Gift",
      img: nacho2,
      resourceIndexes: [1, 2, 3],
    },
    {
      key: "A",
      label: "Areas to Improve",
      img: nacho5,
      resourceIndexes: [4, 5, 6],
    },
    {
      key: "C",
      label: "Chances",
      img: nacho2,
      resourceIndexes: [7, 8, 9],
    },
    {
      key: "H",
      label: "Hurdles",
      img: nacho5,
      resourceIndexes: [10, 11, 12],
    },
    {
      key: "O",
      label: "Out Come",
      img: nacho2,
      resourceIndexes: [13, 14, 15],
    },
  ];


  const faqData = archetypeData
    ? Array.from({ length: 6 }, (_, i) => ({
      title: archetypeData[`toptitle${i + 1}`],
      content: archetypeData[`title${i + 1}`]?.replace(/^`|`$/g, ""),
    }))
    : [];


  const lifeTitles = [
    archetypeData?.lifetitle1,
    archetypeData?.lifetitle2,
    archetypeData?.lifetitle3,
  ];


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [archetypeRes] = await Promise.all([
          axios.get(`${END_URL}/archetypal`)
        ]);

        const archetypeData = archetypeRes.data.archetype;

        if (Array.isArray(archetypeData)) {
          setarchetype(archetypeData);
        } else {
          console.error("Unexpected data format:", archetypeData);
        }

        const HomeData = archetypeRes?.data?.home;

        setBannerData(archetypeRes?.data?.banner_data);

        if (Array.isArray(HomeData)) {

          setHome(HomeData);

        } 

        const seoDate = archetypeRes.seo_page; 

        setSeo(seoDate);

        if (
            archetypeRes.data &&
            archetypeRes.data.data &&
            Array.isArray(archetypeRes.data.data) &&
            archetypeRes.data.data.length > 0
          ) {

          setArchetypeData(archetypeRes.data.data[0]);

        } else {

          console.error("Unexpected archetype data format:", archetypeRes.data.data);
        }

        setError(null);
      } catch (err) {

        console.error('Error fetching data:', err);
        setError('Failed to fetch data');
      } finally {

        setLoading(false);
      }
    };

    fetchData();
  }, []);




  const colRefs = useRef([]);

  const equalizeHeights = () => {
    const colCount = colRefs.current.length;
    if (colCount === 0) return;
  
    colRefs.current.forEach((col) => {
      col.forEach((cell) => {
        if (cell) cell.style.height = "auto";
      });
    });

    const maxRows = Math.max(...colRefs.current.map(col => col.length));
    for (let rowIndex = 0; rowIndex < maxRows; rowIndex++) {
      let maxHeight = 0;
  
      for (let colIndex = 0; colIndex < colCount; colIndex++) {
        const cell = colRefs.current[colIndex][rowIndex];
        if (cell) {
          const height = cell.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        }
      }
  
      for (let colIndex = 0; colIndex < colCount; colIndex++) {
        const cell = colRefs.current[colIndex][rowIndex];
        if (cell) {
          cell.style.height = `${maxHeight}px`;
        }
      }
    }
  
    const colHeights = colRefs.current.map(col =>
      col.reduce((sum, cell) => sum + (cell?.offsetHeight || 0), 0)
    );
    const maxColHeight = Math.max(...colHeights);
  
    colRefs.current.forEach((col, i) => {
      const totalHeight = col.reduce((sum, cell) => sum + (cell?.offsetHeight || 0), 0);
      const paddingNeeded = maxColHeight - totalHeight;
      if (paddingNeeded > 0) {

        if (!colRefs.current[i]._padDiv) {
          const padDiv = document.createElement("div");
          padDiv.style.height = `${paddingNeeded}px`;
          padDiv.style.opacity = 0;
          padDiv.style.pointerEvents = "none";
          padDiv.style.userSelect = "none";
          col[col.length - 1]?.parentNode?.appendChild(padDiv);
          colRefs.current[i]._padDiv = padDiv;
        } else {
          colRefs.current[i]._padDiv.style.height = `${paddingNeeded}px`;
        }
      }
    });
  };
  
  

  useEffect(() => {
    const handleResize = () => equalizeHeights();
    setTimeout(equalizeHeights, 100); // wait for render
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [archetypeData, nachoSections]);

  
  return (
    <>
        <Helmet>

                  <title>{seo?.meta_title || 'Personality Assessment Test with Models | Personality Peek '}</title>

                  <meta name="description" content={seo?.meta_description || 'Try our free personality assessment test to uncover your traits, strengths, and archetype. Fun, fast, and insight-driven results'} />

                  <meta name="keywords" content={seo?.meta_keywords || 'personality assessment test , personality test'} />
                  
                  {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
                  {seo?.og_description && <meta property="og:description" content={seo.og_description} />}
                  {seo?.og_image && <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />}
                  {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
                  {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

                  {seo?.twitter_title && <meta name="twitter:title" content={seo.twitter_title} />}
                  {seo?.twitter_description && <meta name="twitter:description" content={seo.twitter_description} />}
                  {seo?.twitter_image && <meta name="twitter:image" content={`${IMG_URL}/d0/${seo.twitter_image}`} />}
                  {seo?.twitter_card && <meta name="twitter:card" content={seo.twitter_card} />}

                  {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

                  {!seo?.og_title && <meta property="og:title" content="PersonalityTest - Discover Your True Archetype | Personality Peek" />}
                  {!seo?.og_description && <meta property="og:description" content="Try our free personality assessment test to uncover your traits, strengths, and archetype. Fun, fast, and insight-driven results" />}
                  {!seo?.og_type && <meta property="og:type" content="website" />}
                  {!seo?.twitter_card && <meta name="twitter:card" content="summary_large_image" />}

          </Helmet>


    {loading ? (
      <div
        className="loadingDiv"
            >
              <img
                src={gg}
                alt="Loading..."
                  className=""          />
            </div>
    ) : (

        <div className='asm-det-cont'>

          <div className="asm-banner-div">

            <div className="container-fluid">

              <div className="row">

                <div class="asm-banner-wrapper" style={{
                                      background: `url(${IMG_URL}/d0/${archetypeData?.image1}) no-repeat center center`,
                                    }}>
                  <div className="asm-banner-imgDiv">
          
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: archetypeData?.maintitle }} />

                </div>
              </div>

            </div>

          </div>

          <Archetype data={BannerData} />

          <Testimonial data={BannerData} free_test_slug={free_test_slug} />

          <Popularity data={BannerData} />

          <div className="asm-det-subnach-box-div">
            <div className="container">

              <div className="row asm-subnach-btn">
                <div className="col-12">
                  <h3>{archetypeData?.nacho_text_title}</h3>
                  <a className="home-slider-sun-box-a asm-det-btn" href="">
                  <a href="/test/free-starter-quiz" className="home-slider-sun-box-a-text">{archetypeData?.nacho_button_label}</a>
                    <span className="home-slider-sun-box-a-icon">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>


          <div className="asm-det-img-div">

              <div className="container-fluid">
                <div className="row">

                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="asm-single-imgDiv">
                      <img src={`${IMG_URL}/d0/${archetypeData?.image3}`} alt="" />
                    </div>
                  </div>

                </div>
              </div>
          </div>

          <div className="asm-asm-home-div">

            <Asm data={home} archetype={archetype} asm_page={asm_page} />

            <div className="container">

              <div className="row asm-subnach-btn asm-repeat-btn-row">

                <div className="col-12 col-sm-12 col-md-12">




                  <h3>{home?.[0]?.asm_bottom_heading}</h3>
                  
                  <a className="home-slider-sun-box-a asm-det-btn" href="">
                <a href="/test/free-starter-quiz" className="home-slider-sun-box-a-text"> {home?.[0]?.asm_bottom_button} </a>

                    <span className="home-slider-sun-box-a-icon">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>

                </div>

              </div>
            </div>

          </div>

          <div className="asm-det-faq-div">

            <div className="container">
              <div className="row">

                <h2>{home?.[0]?.asm_works_heading}</h2> 

                <div className="col-12 col-sm-12 col-md-12">
                  <div className="faq-container">
                    {faqData.map((item, index) => (
                      <div key={index} className="faq-item" onClick={() => toggle(index)}>
                        <div className="faq-title">
                          <h3>{item.title}</h3>
                          <span className="arrow-icon">
                            <img className={openIndex === index ? "rotate1" : ""} src={arr} alt="" />
                          </span>
                        </div>
                        {openIndex === index && (
                          <div className="faq-content">
                            <p dangerouslySetInnerHTML={{ __html: item?.content }}></p>
                          </div>
                        )}
                        <hr />
                      </div>
                    ))}
                  </div>
                </div>


              </div>

            </div>

          </div>

           <div className="asm-det-img-div">

              <div className="container-fluid">

                <div className="row">


                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="asm-single-imgDiv">

                      <img src={`${IMG_URL}/d0/${archetypeData?.image2}`} alt="Apply NACHO free personality assessment insights for personal growth, better decisions, relationships, and stress management." />
                      
                    </div>
                  </div>

                </div>

              </div>

          </div>

          <div className="asm-det-cta-div">

            <div className="container">

              <div className="row">

                <div className="col-12 col-sm-12 col-md-12">

                  <div className="asm-det-cta-box">
                    <div dangerouslySetInnerHTML={{ __html: archetypeData?.subtitle1 }} />
                    <a className="home-slider-sun-box-a asm-det-btn" href="">
                    <a href="/test/free-starter-quiz" className="home-slider-sun-box-a-text"> {home?.[0]?.asm_button_label} </a>
                      <span className="home-slider-sun-box-a-icon">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>


                  </div>

                </div>

              </div>

            </div>

          </div>


          <div className="asm-nach-div">


            <div className="container">

              <div className="row asm-nach-row" dangerouslySetInnerHTML={{ __html: archetypeData?.subtitle2 }} >

              </div>

              <div className="row asm-nach-cards-row">

                <div className="col-12 col-sm-6 col-md-4 col-lg-2-5">
                  <div className="asm-nach-box">
                    <img src={`${IMG_URL}/d0/${archetypeData?.nacho_image_1}`} alt="Discover your Natural Gifts through the NACHO free personality assessment for personal growth and insight" />

                    <h6> {archetypeData?.nacho_title_1} </h6>
                  </div>

                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-2-5">
                  <div className="asm-nach-box">
                    <img src={`${IMG_URL}/d0/${archetypeData?.nacho_image_2}`} alt="Identify key Areas to Improve with the NACHO free personality assessment for better self-awareness and success" />

                    <h6> {archetypeData?.nacho_title_2} </h6>
                  </div>

                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-2-5">
                  <div className="asm-nach-box">
                    <img src={`${IMG_URL}/d0/${archetypeData?.nacho_image_3}`} alt="Explore new Chances and opportunities using the NACHO free personality assessment for goal achievement" />

                    <h6>{archetypeData?.nacho_title_3}</h6>
                  </div>

                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-2-5">
                  <div className="asm-nach-box">
                    <img src={`${IMG_URL}/d0/${archetypeData?.nacho_image_4}`} alt="Overcome Hurdles effectively with the NACHO free personality assessment for confidence and progress
" />

                    <h6> {archetypeData?.nacho_title_4} </h6>
                  </div>

                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-2-5">
                  <div className="asm-nach-box">
                    <img src={`${IMG_URL}/d0/${archetypeData?.nacho_image_5}`} alt="Achieve positive Outcomes with the NACHO free personality assessment designed for growth and reflection" />

                    <h6> {archetypeData?.nacho_title_5} </h6>
                  </div>

                </div>

              </div>


              <div className="row asm-nach-sub-row">
                <div className="col-12 col-sm-12 col-md-12">
                  <div dangerouslySetInnerHTML={{ __html: archetypeData?.subtitle3 }} />
                </div>
              </div>

            </div>

          </div>

    
          <div className="asm-apply-cont">
            <div className="container">
              <h2>{archetypeData?.nacho_every_day_title}</h2>
              <div className="row gy-4">
                {lifeTitles.map(
                  (html, idx) =>
                    html && (
                      <div className="col-12 col-sm-6 col-md-4" key={idx}>
                        <div className="asm-apply-text">
                          <div dangerouslySetInnerHTML={{ __html: html }} />
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>

          <div className="asm-gland-cont">
            <div className="container">

              <div className="row">

                <div className="col-12 col-sm-12 col-md-4">
                  <div className="asm-gland-img">
                    <img src={`${IMG_URL}/d0/${archetypeData?.asm_paragraph_image}`} alt="Spice up self-discovery with NACHO free personality assessment for fun, confidence, growth, and meaningful life insights." />
                  </div>
                </div>

                <div className="col-12 col-sm-12 col-md-8">
                  <div className="asm-gland-content">

                    <div dangerouslySetInnerHTML={{ __html: archetypeData?.parafraph }} />

                      <a className="home-slider-sun-box-a asm-det-btn">

                      {token ? (

                        <span onClick={AttendTest} className="home-slider-sun-box-a-text">{archetypeData?.nacho_every_day_btn}</span>

                      ): (

                        <span onClick={LoginShow} className="home-slider-sun-box-a-text">{archetypeData?.nacho_every_day_btn}</span>

                      )}

                        <span className="home-slider-sun-box-a-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>

                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>
        )}

 </> )
}

export default AsmDetail